import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import gameFormHeaderStyles from './gameFormHeader.styles'

const useStyles = makeStyles(gameFormHeaderStyles)

const GameFormHeader = ({ title, titleContent, onClose }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.titleRow}>
        {/* When a titleContent (e.g. the event-type selector, on create) is provided it stands in
            for the chip + static title, so the header shows a single identity, not a duplicate. */}
        {titleContent || (
          <>
            <span className={classes.iconChip} />
            <span className={classes.title}>{title}</span>
          </>
        )}
        {onClose && (
          <IconButton
            className={classes.closeButton}
            size='small'
            onClick={onClose}
            aria-label='close'
          >
            <CloseIcon fontSize='small' />
          </IconButton>
        )}
      </div>
    </div>
  )
}

GameFormHeader.propTypes = {
  title: PropTypes.string,
  titleContent: PropTypes.node,
  onClose: PropTypes.func,
}

GameFormHeader.defaultProps = {
  title: 'Game',
}

export default GameFormHeader
